/* eslint-disable camelcase */
import * as marietta from '../..';
import * as marietta3d from '../../../marietta3d';
import { ITEM_MODE_KEY, BUILDING_TYPE_MANSION } from '../Constants';
import MasterItemCollection from './MasterItemCollection';
import DocumentCollection from './DocumentCollection';
import { RecogninzeInfo } from '../util/LiDAR/MarkInterface';
import { AuxiliaryData } from '../util/LiDAR/AuxiliaryInterface';
import { ExtrasType } from '../../view3d/webcad/WebCadDefines';

export type PointJsonType = {
  index:number,
  x:number,
  y:number,
  ceiling_x:number,
  ceiling_y:number,
  wall_type?:number,
  road_w?:number,
  road_lr?:boolean,
  type: number,
  guid: string,
  material:{ inner: string, outer: string },
  inner_end_item_info:MasterItemCollection;
  outer_end_item_info:MasterItemCollection;
  habaki_end_item_info:MasterItemCollection;
  inner_white_item_info:MasterItemCollection;
  outer_white_item_info:MasterItemCollection;
  habaki_white_item_info:MasterItemCollection;
  wall_documents:DocumentCollection[];
  habaki_documents:DocumentCollection[];
}
export interface LinkType {
    id?: string;
    name: string;
    url: string;
    binary?: string;
};
export interface RemarksType {
    id: string,
    text: string
};

/** linkedAt: 手動で紐づけを確定し部屋名を決めた時刻。同じアイテムに複数ピンが紐づくとき最新を正とする */
export interface IntersectItemType {uid: string, type: ExtrasType, linkedAt?: number};

class ItemInfoCollection {
    id: string;

    guid: string;

    x: number;

    y: number;

    floor: number;

    index: number;

    rotation: number = 0;

    transformMatrix: number[] = [];

    lock: boolean;

    imgSrc: string; // imageタグ読み込み用

    width: number;

    height: number;

    depth: number; // WEBCADV15-1323 オブジェクトのスケール調整の追加

    use_mm: boolean = false;

    widthmm: number;

    heightmm: number;

    dotList: marietta.webcad.collection.PointCollection[] = [];

    color: string;

    designColor: string;

    design_type: string;

    _lr: boolean;

    set lr(bool: boolean) {
      this._lr = bool;
    }

    get lr() {
      return this._lr;
    }

    // テキスト情報
    text: string;

    textPosition: marietta.core.Point;

    text_visible: boolean = true;

    text_area_visible: boolean = true;

    text_ceiling_visible: boolean = true;

    area_use_jyou: boolean = true;

    auto_layout = true;

    // 建具情報
    auto_height: boolean = true;

    fitting_height: number;

    z: number;

    // 3DのID
    idthreed: string = 'null';

    // エンドアイテムの情報
    end_item_info:MasterItemCollection = null;
    white_item_info:MasterItemCollection = null;

    floor_end_item_info: MasterItemCollection = null;
    floor_white_item_info: MasterItemCollection = null;

    ceiling_end_item_info: MasterItemCollection = null;
    ceiling_white_item_info: MasterItemCollection = null;

    // 屋根情報
    roof_type: number;

    roof_direction: number;

    // サイトベースラインインデックス
    baseNo: number;

    xCoords: number[];// 通り芯

    yCoords: number[];// 通り芯

    line_color: string = '#000000';

    stroke_array: number[];

    // テキストアイテムのプロパティ
    text_color: string;

    font_size: number;

    is_bold: boolean;

    is_underline: boolean;

    is_italic: boolean;

    is_strike_through: boolean;

    text_alignment: string = 'left';

    is_wall_item:boolean = false;

    is_ceiling_item:boolean = false;

    material:{ ceiling:string, wall:string, kosi:string, habaki:string, floor:string }={ ceiling: null, wall: null, kosi: null, habaki: null, floor: null };

    ceiling_hang_height:number = 0;

    parentRoom: marietta.webcad.item.Room;

    area: number = 0;

    link: LinkType[] = []; // beforeの写真

    // link_binary:string[];

    after_link: LinkType[] = []; // afterの写真
    public pin_id: string = ''; // DB用の登録ピンID
    public is_register_img: boolean = false;   // 画像登録が必要か否か
    public is_pin_update_flg: boolean = false; // ピン更新フラグ

    public remarks: RemarksType[] = []; // 備考

    /** DB用 ローカルFileをアップロードした際の画像登録API 返り値 */
    public file_id: string = '';

    // after_link_binary:string[];

    ceiling_documents:DocumentCollection[] = [];
    floor_documents:DocumentCollection[] = [];
    documents:DocumentCollection[] = [];

    public auxiliaryData: AuxiliaryData = null;

    // 画像検知データ
    public recognizeData: RecogninzeInfo = null;

    public intersectItem: IntersectItemType = null; // ピンの衝突判定アイテムID

    //部屋の巾木高さ
    public habaki_height:number;

    /**
     * コンストラクタ
     */
    constructor() {
      this.lock = false;
      this.lr = false;
      this.id = '';
      this.material = {
        ceiling: null,
        wall: null,
        kosi: null,
        habaki: null,
        floor: null,
      };
    }

    /**
     * クローン
     */
    clone(newGuid: boolean = false): marietta.webcad.collection.ItemInfoCollection {
      const ret: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
      ret.id = this.id;
      ret.guid = this.guid;
      ret.x = this.x;
      ret.y = this.y;
      ret.floor = this.floor;
      ret.rotation = this.rotation;
      ret.transformMatrix = this.transformMatrix;
      ret.width = this.width;
      ret.height = this.height;
      ret.widthmm = this.widthmm;
      ret.heightmm = this.heightmm;
      if (this.dotList !== undefined) {
        ret.dotList = [];
        for (let i = 0; i < this.dotList.length; i += 1) {
          ret.dotList.push((this.dotList[i] as marietta.webcad.collection.PointCollection).clone(newGuid));
        }
      }
      ret.color = this.color;
      ret.designColor = this.designColor;
      ret.design_type = this.design_type;
      ret.lr = this.lr;
      ret.text = this.text;
      ret.textPosition = this.textPosition;
      ret.text_visible = this.text_visible;
      ret.text_area_visible = this.text_area_visible;
      ret.area_use_jyou = this.area_use_jyou;
      ret.auto_layout = this.auto_layout;
      ret.idthreed = this.idthreed;
      ret.auto_height = this.auto_height;
      ret.z = this.z;
      ret.fitting_height = this.fitting_height;
      ret.roof_type = this.roof_type;
      ret.use_mm = this.use_mm;
      ret.baseNo = this.baseNo;
      ret.text_color = this.text_color;
      ret.font_size = this.font_size;
      ret.is_bold = this.is_bold;
      ret.is_underline = this.is_underline;
      ret.is_italic = this.is_italic;
      ret.is_strike_through = this.is_strike_through;
      ret.text_alignment = this.text_alignment;
      ret.is_wall_item = this.is_wall_item;
      ret.is_ceiling_item = this.is_ceiling_item;
      ret.depth = this.depth;
      ret.material = this.material;
      ret.parentRoom = this.parentRoom;
      ret.floor_end_item_info = this.floor_end_item_info;
      ret.ceiling_end_item_info = this.ceiling_end_item_info;
      ret.end_item_info = this.end_item_info;
      ret.link = this.link;
      ret.after_link = this.after_link;
      ret.pin_id = ''; // API登録するため初期化
      ret.is_register_img = this.is_register_img; // 画像登録が必要
      ret.ceiling_hang_height = this.ceiling_hang_height;
      ret.ceiling_documents = this.ceiling_documents;
      ret.floor_documents = this.floor_documents;
      ret.documents = this.documents;
      ret.habaki_height = this.habaki_height;
      return ret;
    }

    /**
     * ホワイトアイテムか否か
     */
    isWhiteItem() {
      if( this.end_item_info != null ){
        return false;
      }
      return true;

      // switch (this.idthreed) {
      //   case 'null':
      //   case null:
      //   case '':
      //   case undefined:
      //     return true;
      //   default:
      //     break;
      // }
      //
      // // ホワイトアイテムのコードだったら
      // if (this.id === this.idthreed) {
      //   return true;
      // }
      // return false;
    }

    /**
     * 頂点一覧の取得
     */
    getPointJSON(type:string): PointJsonType[] {
      const pointList:PointJsonType[] = [];
      let pointObj:PointJsonType;
      const isRoom:boolean = (type === ITEM_MODE_KEY.MODE_ROOM_KEY);
      const isStair:boolean = (type === ITEM_MODE_KEY.MODE_STAIR_KEY);
      const isSite:boolean = (type === ITEM_MODE_KEY.MODE_SITE_KEY);
      const isWall:boolean = (type === ITEM_MODE_KEY.MODE_WALL_KEY);
      const isRoof:boolean = (type === ITEM_MODE_KEY.MODE_ROOF_KEY);
      const isColumn:boolean = (type === ITEM_MODE_KEY.MODE_COLUMN_KEY);
      const isBeam:boolean = (type === ITEM_MODE_KEY.MODE_BEAM_KEY);

      for (let i = 0, len = this.dotList.length; i < len; i += 1) {
        pointObj = <PointJsonType>{};
        pointObj.index = i + 1;
        if (isStair) {
          pointObj.x = this.dotList[i].x;
          pointObj.y = -this.dotList[i].y;
        } else if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          pointObj.x = marietta.webcad.util.WebCADUtil.convertPixToMM(this.dotList[i].x + this.x);
          pointObj.y = -((marietta.webcad.util.WebCADUtil.convertPixToMM(this.dotList[i].y) + marietta.webcad.util.WebCADUtil.convertPixToMM(this.y)) - marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H));
        } else {
          pointObj.x = this.dotList[i].x + this.x;
          pointObj.y = -(this.dotList[i].y + this.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H);
        }
        if (this.dotList[i].guid != null) pointObj.guid = this.dotList[i].guid;
        // 部屋用
        if (isRoom || isStair || isWall || isColumn ) {

          pointObj.material = this.dotList[i].material;
          pointObj.inner_end_item_info = this.dotList[i].inner_end_item_info;
          pointObj.inner_white_item_info = this.dotList[i].inner_white_item_info;
          pointObj.habaki_white_item_info = this.dotList[i].habaki_white_item_info;

          if (isRoom) {
            pointObj.wall_documents = this.dotList[i].wall_documents;
            pointObj.habaki_documents = this.dotList[i].habaki_documents;
          }

          if( !isColumn && !isBeam){
            pointObj.wall_type = this.dotList[i].wall_type;
            pointObj.outer_end_item_info = this.dotList[i].outer_end_item_info;
            pointObj.outer_white_item_info = this.dotList[i].outer_white_item_info;
          }
        }
        if (isRoof) {
          pointObj.type = this.dotList[i].type;
        }

        if (isSite) {
          pointObj.road_w = this.dotList[i].road_w;
          pointObj.road_lr = this.dotList[i].road_lr;
        }

        pointList.push(pointObj);
      }
      return pointList;
    }

    get globalDotListAsNumArray(): number[][] {
      const retList: number[][] = [];
      for (let i: number = 0; i < this.dotList.length; i += 1) {
        retList.push([this.dotList[i].x + this.x, this.dotList[i].y + this.y]);
      }
      return retList;
    }

    get globalDotList(): marietta.webcad.collection.PointCollection[] {
      const retList: marietta.webcad.collection.PointCollection[] = [];
      for (let i: number = 0; i < this.dotList.length; i += 1) {
        retList.push(new marietta.webcad.collection.PointCollection(this.dotList[i].x + this.x, this.dotList[i].y + this.y, this.dotList[i].wall_type));
      }
      return retList;
    }

    /**
     *
     */
    updateArea() {
      if (this.id.substring(0, 3) === 'fit') {
        let width = 0;
        let height = 0;
        if (this.end_item_info != null) {
          width = this.end_item_info.item_width;
          height = this.end_item_info.item_height;
        } else {
          width = this.widthmm;
          height = this.fitting_height;   //手動高さ
          //手動高さの設定がなければ、3Dのデフォルト高さを取得
          if( isNaN(height) || height === 0 ) height = marietta.webcad.WebCADGlobal.getFittingHeight(this.idthreed && this.idthreed !== 'null' ? this.idthreed : this.id);
        }
        this.area = parseFloat(((width / 1000) * (height / 1000)).toFixed(3));
      }
    }

    /**
     * アイテムの囲み座標を取得
     * 建具の場合は2点分、部屋・家具等は3点以上
     */
    public getItemPointAry(): marietta3d.AutoGen.utils.RoomPointArray {
      const points = new marietta3d.AutoGen.utils.RoomPointArray();
      if (this.dotList.length) {
        // 部屋
        const p = this.dotList.map((dot) => new marietta.core.Point(this.x + dot.x, this.y + dot.y));
        points.push(...p);
        return points;
      } else if (this.width && !this.height) {
        // 建具等
        const w = this.width / 2;
        const center = new marietta.core.Point(this.x, this.y);
        const pointS = new marietta.core.Point(this.x + w, this.y);
        const pointE = new marietta.core.Point(this.x - w, this.y);
        pointS.rotation(center, this.rotation);
        pointE.rotation(center, this.rotation);
        points.push(pointS, pointE);
      } else if (this.width && this.height) {
        // 家具、住設等
        const w = this.width / 2;
        const h = this.height / 2;
        const center = new marietta.core.Point(this.x, this.y);
        const point1 = new marietta.core.Point(this.x + w, this.y-h);
        const point2 = new marietta.core.Point(this.x + w, this.y+h);
        const point3 = new marietta.core.Point(this.x - w, this.y+h);
        const point4 = new marietta.core.Point(this.x - w, this.y-h);
        points.push(point1, point2, point3, point4);
        points.Rotation(center, this.rotation);
      } else if (!this.width && !this.height) {
        // 点
        points.push(new marietta.core.Point(this.x, this.y));
      }
      return points;
    }
}
export default ItemInfoCollection;
